import { Box, Typography } from '@mui/material'
import ContactCard from 'src/components/Contact/ContactCard'
import { contacts } from 'src/components/Contact/enums'

const Contact = () => {
  return (
    <Box>
      <Box
        sx={{
          height: {
            xs: 'calc(100vh - 56px)',
            sm: 'calc(70vh - 65px)',
            md: 'calc(100vh - 65px)',
          },
          maxHeight: '1200px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          color: '#f3f3f3',
          py: { xs: 6, md: 0 },
        }}
      >
        <Typography
          variant="h4"
          fontWeight={600}
          fontStyle="italic"
          color="primary"
          sx={{ mt: { xs: 2, md: 0 } }}
        >
          Get in touch
        </Typography>
        <Box
          sx={{
            mt: { xs: 3, sm: 8, md: 10 },
            width: { xs: '80%', sm: '100%', md: '80%' },
            mx: 'auto',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-evenly',
          }}
        >
          {contacts.map((contact, index) => (
            <ContactCard {...contact} key={index} />
          ))}
        </Box>
      </Box>
      <Box
        sx={{
          pt: 5,
          pb: 7,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: { xs: '90%', md: '70%' },
          mx: 'auto',
        }}
      >
        <Typography
          variant="h4"
          fontWeight={600}
          fontStyle="italic"
          sx={{ mb: 6 }}
          color="primary"
        >
          Google Maps Location
        </Typography>
        <iframe
          title="Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d606.5729001495068!2d21.156583299999994!3d42.651277799999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x39d4ff06df5c7c0a!2zNDLCsDM5JzA0LjYiTiAyMcKwMDknMjMuNyJF!5e1!3m2!1sen!2s!4v1652551418540!5m2!1sen!2s"
          width="100%"
          height="600"
          style={{ border: 0, borderRadius: '20px' }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </Box>
    </Box>
  )
}

export default Contact
